export const UPDATE_STATEMENT_TEMPLATE_FAILURE = 'UPDATE_STATEMENT_TEMPLATE_FAILURE';

export const updateStatementTemplateFailure = error => ({
    type: UPDATE_STATEMENT_TEMPLATE_FAILURE,
    payload: error,
    error: true,
});
